module.exports = __webpack_public_path__ + "./assets/modal_qr_desktop_member__4a70085fea306e00e8e91ea02e990996.png";